import { createContext } from "react";

// Lets a page render content into the site-level Header (e.g. the mobile search
// bar next to the hamburger). The layout owns the slot element; the Header sets it
// via a ref, and a page portals into it. Null when no slot is mounted (desktop).
type HeaderSlotValue = {
  slotEl: HTMLElement | null;
  setSlotEl: (el: HTMLElement | null) => void;
};

export const HeaderSlotContext = createContext<HeaderSlotValue>({
  slotEl: null,
  setSlotEl: () => {}
});
